import { render, staticRenderFns } from "./DataRepoInfo.vue?vue&type=template&id=8ed03ff6&"
import script from "./DataRepoInfo.vue?vue&type=script&lang=ts&"
export * from "./DataRepoInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DataRepoInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports